import './SharedChannelsCarousel.css';
import React, { useEffect, useState } from 'react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get } from '../../utils';
import { SharedChannelCards } from '../atoms/SharedChannelsCards/SharedChannelsCards';
import getListing from '../../utils/getListing';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../atoms/RouterLink';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { ReactComponent as RightCarouselArrow } from "../../resources/icons/chevronRightCarouselSharedCh.svg";
import { ReactComponent as LeftCarouselArrow } from "../../resources/icons/chevronLeftCarouselSharedCh.svg";
import { checkJssError } from '../../utils/checkJssError';
const getFacetNamesValue = filterData => filterData ? filterData.map(filter => get(filter, 'fieldNameItem.item.fieldName.value')) : [];
const extractTags = filterData => {
  if (!Array.isArray(filterData)) return [];
  const result = [];
  for (const item of filterData) {
    var _item$fieldNameItem, _item$tagsToDisplay;
    const fieldName = item === null || item === void 0 || (_item$fieldNameItem = item.fieldNameItem) === null || _item$fieldNameItem === void 0 || (_item$fieldNameItem = _item$fieldNameItem.item) === null || _item$fieldNameItem === void 0 || (_item$fieldNameItem = _item$fieldNameItem.fieldName) === null || _item$fieldNameItem === void 0 ? void 0 : _item$fieldNameItem.value;
    const tags = (item === null || item === void 0 || (_item$tagsToDisplay = item.tagsToDisplay) === null || _item$tagsToDisplay === void 0 ? void 0 : _item$tagsToDisplay.values) || [];
    for (const tag of tags) {
      var _tag$title;
      const title = tag === null || tag === void 0 || (_tag$title = tag.title) === null || _tag$title === void 0 ? void 0 : _tag$title.value;
      if (fieldName && title) {
        result.push(`${fieldName}:${title}`);
      }
    }
  }
  return result;
};
const SharedChannelsCarouselComponent = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const algoliaIndexes = get(params, 'SearchIndex');
  const searchCount = get(params, 'SearchCount');
  const title = get(fields, 'data.configuration.title.jss') || "";
  const ctaLabel = get(fields, 'data.configuration.ctaLabel.jss.value') || "";
  const ctaLink = get(fields, 'data.configuration.ctaLink.jss.value.href') || "";
  const ctaLinkType = get(fields, 'data.configuration.ctaLink.jss.value.linktype') || "";
  const ctaLeftIcon = get(fields, 'data.configuration.ctaLeftIcon.targetItem.svg.jss.value') || "";
  const ctaRightIcon = get(fields, 'data.configuration.ctaRightIcon.targetItem.svg.jss.value') || "";
  const filterData = get(fields, 'data.configuration.filters.values') || [];
  const typeArray = get(fields, 'data.configuration.contentType.types') || [];
  const BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  const [loading, setLoading] = React.useState(false);
  const [hits, setHits] = React.useState([]);
  const [closeComponent, setCloseComponent] = React.useState(false);
  const [isMobile, setIsMobile] = useState(canUseDOM && window.matchMedia('(max-width: 767px)').matches);
  const checkIsMobile = () => {
    const isMobile = canUseDOM && window.innerWidth <= 767;
    setIsMobile(isMobile);
  };
  useEffect(() => {
    window.addEventListener('resize', checkIsMobile);
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);
  const facetNames = getFacetNamesValue(filterData);
  let types = typeArray.map(type => {
    let value = type && type.template.targetItem.value;
    return `type:${value}`;
  });
  const extractedTags = extractTags(filterData);
  const switchItemFilters = {
    facets: [...facetNames],
    facetFilters: [[...types], extractedTags],
    hitsPerPage: searchCount
  };
  const listingRequest = () => {
    setLoading(true);
    getListing(algoliaIndexes, switchItemFilters, algoliaSettings, undefined, false).then(response => {
      setHits(hits.concat(response.hits));
    }).catch(error => {
      console.error('Error:', error);
      setCloseComponent(true);
    }).finally(() => setLoading(false));
  };
  useEffect(() => {
    listingRequest();
  }, []);
  if (closeComponent) {
    console.info('SharedChannelsCarousel component render skipped. No fields provided');
    return null;
  }
  const renderItems = classForCards => {
    return hits.map((hit, index) => /*#__PURE__*/React.createElement(SharedChannelCards, {
      hit: hit,
      rtl: rtl,
      className: classForCards,
      BASE_URL: BASE_URL,
      key: index
    }));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, (title === null || title === void 0 ? void 0 : title.value) && /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "carouselTitle",
    field: title
  }), loading && /*#__PURE__*/React.createElement("div", {
    className: "Listing Listing--loader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loader-t1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loadingio-spinner-rolling-arlp0sgzkfu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ldio-fryp34cx4ij"
  }, /*#__PURE__*/React.createElement("div", null))))), hits.length === 1 && !isMobile ? /*#__PURE__*/React.createElement("div", {
    className: "onlyOneCard"
  }, renderItems()) : null, hits.length <= 3 && isMobile ? /*#__PURE__*/React.createElement("div", {
    className: "verticalCards"
  }, renderItems()) : null, hits.length <= 3 && hits.length !== 1 && !isMobile ? /*#__PURE__*/React.createElement("div", {
    className: "hirizontalCards"
  }, renderItems()) : null, hits.length >= 4 ? /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots,
      state
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "card-container__inner"
    }, renderCarousel(renderItems("cardsHeight"), {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1101
          },
          items: 3
        },
        desktop: {
          breakpoint: {
            max: 1100,
            min: 900
          },
          items: 3
        },
        table_portrait: {
          breakpoint: {
            max: 899,
            min: 768
          },
          items: 2
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 480
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      }
    })), state.dotsTotal && state.dotsTotal > 1 ? /*#__PURE__*/React.createElement("div", {
      className: `pagination-dot ${ctaLabel && ctaLink ? 'paginationWithButton' : 'paginationWithoutButton'}`
    }, renderDots(() => {}, [], false, '')) : null, hits ? /*#__PURE__*/React.createElement("div", {
      className: "ctaLabelWithButtons"
    }, ctaLabel && ctaLink && /*#__PURE__*/React.createElement(RouterLink, {
      className: "btn btn-primary",
      href: ctaLink,
      title: ctaLabel,
      linktype: ctaLinkType,
      ctaLeftIcon: ctaLeftIcon,
      ctaRightIcon: ctaRightIcon,
      rtl: rtl
    }, /*#__PURE__*/React.createElement("span", {
      className: "linkText"
    }, ctaLabel)), /*#__PURE__*/React.createElement("div", {
      className: "pagination__btn"
    }, /*#__PURE__*/React.createElement("div", {
      className: `btn-group--right ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => {}, false, false, /*#__PURE__*/React.createElement(LeftCarouselArrow, {
      className: "icon"
    })), renderNextButton(() => {}, false, false, /*#__PURE__*/React.createElement(RightCarouselArrow, {
      className: "icon"
    }))))) : null);
  }) : null);
};
const SharedChannelsCarousel = props => checkJssError(props, SharedChannelsCarouselComponent, props.fields.data.configuration);
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    className,
    anchorUrlParameter,
    style
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    style: style,
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
const commonStyles = "c15fb6t1";
const ltrStyles = "l1q3mu3h";
const rtlStyles = "r15uds32";
export default SharedChannelsCarousel;